import { Box, Button, FormInput } from 'components'
import { usePostQuery } from 'hooks'
import { useState } from 'react'

export const HostCreateKaraokeQueue = ({
  clearActivity,
  parentId,
  parentType
}) => {
  const [state, setState] = useState({ count: 10 })

  const { data, isFetching, error, post } = usePostQuery({
    method: 'POST',
    url: '/host/queue'
  })

  const handler = ({ target: { name, value } }) => {
    setState({ ...state, [name]: value })
  }

  const createQueue = () => {
    post({
      name: state.name,
      parent_type: parentType,
      parent_id: parentId,
      type: 'karaoke'
    }).then()
  }

  return (
    <Box>
      <FormInput
        label="Name your game"
        name="name"
        onChange={handler}
        value={state?.name}
      />
      <Button onPress={createQueue}>Add</Button>
    </Box>
  )
}
